import { colorsTuple, createTheme } from '@mantine/core'
import css from './theme.module.scss'

export const themeCfg = {
  debug: false,
  breakpoint: 'sm',
  headerSize: 60,
  footerSize: 0,
  navbarSize: 230,
  default: {
    gap: 'xs',
    padding: 'xs',
    radius: 'sm',
  },
  commonProps: {
    m: 0,
    p: 0,
    ff: 'Gilroy Regular, sans-serif',
  },
}

export const theme = createTheme({
  fontFamily: 'Gilroy, sans-serif',
  primaryColor: 'moure-blue',
  fontSmoothing: false,
  cursorType: 'pointer',
  defaultRadius: themeCfg?.default?.radius,
  colors: {
    primary: colorsTuple('#122866'),
    'moure-blue': colorsTuple('#122866'),
    'moure-orange': colorsTuple('#ef6a20'),
    'moure-white': colorsTuple('#f2f3f9'),
    'bg-container': colorsTuple('#e9ebf5'),
    white: colorsTuple('#ffffff'),
    text: colorsTuple('#666677'),
  },

  components: {
    AppShell: {
      defaultProps: {
        ...themeCfg?.commonProps,
      },
    },
    Stack: {
      defaultProps: {
        gap: themeCfg?.default?.gap,
      },
    },
    Group: {
      defaultProps: {
        ...themeCfg?.commonProps,
        wrap: 'nowrap',
        display: 'flex',
        align: 'center',
        h: '100%',
        gap: themeCfg?.default?.gap,
      },
    },

    SimpleGrid: {
      defaultProps: {
        // ...themeCfg?.commonProps,
        w: '100%',
        h: '100%',
        mih: '100%',
        gap: themeCfg?.default?.gap,

        // pb: themeCfg?.default?.padding
      },
    },

    Avatar: {
      defaultProps: {
        ...themeCfg?.commonProps,
        className: css.avatar, // Use the imported CSS module class
      },
    },

    Button: {
      defaultProps: {
        // ...themeCfg?.commonProps,
        // className: css.button,
        // miw: 140,
        // h: 36,
        // mah: 36,
        px: 'xs',
        py: 0,
      },
    },

    Card: {
      defaultProps: {
        ...themeCfg?.commonProps,
        className: css.card,
      },
    },

    Tabs: {
      defaultProps: {
        ...themeCfg?.commonProps,
        className: css.tabs,
      },
    },

    Paper: {
      defaultProps: {
        w: '100%',
        // h: "100%",
        p: 'lg',
        bg: 'moure-white',
        // overflow: "hidden",
        withBorder: true,
        shadow: 'xs',
      },
    },

    Input: {
      classNames: {
        input: css.inputInput,
        section: css.inputSection,
      },
      defaultProps: {
        ff: themeCfg?.commonProps?.ff,
      },
    },

    Select: {
      defaultProps: {
        className: css.select,
        classNames: {
          select: css.select,
          input: css.selectInput,
          wrapper: css.selectWrapper,
          dropdown: css.selectDropdown,
          option: css.selectOption,
        },
        w: '100%',
        // miw: 140,
      },
    },
    DateInput: {
      defaultProps: {
        classNames: {
          input: css.dateInputInput,
        },
      },
    },

    Checkbox: {
      defaultProps: {
        classNames: {
          root: css.checkbox,
          icon: css.checkboxIcon,
          label: css.checkboxLabel,
        },
        cursor: 'pointer',
      },
    },

    Tooltip: {
      defaultProps: {
        className: css.tooltip,
        openDelay: 500,
        bg: 'moure-orange',
        fz: '80%',
        fw: 100,
        arrowSize: 8,
        withArrow: true,
      },
    },

    NumberInput: {
      classNames: {
        input: css.numberInputInput,
      },
      defaultProps: {
        thousandSeparator: '.',
        decimalSeparator: ',',
        decimalScale: 2,
        fixedDecimalScale: true,
      },
    },

    NumberFormatter: {
      defaultProps: {
        className: css.numberFormatter,
        thousandSeparator: '.',
        decimalSeparator: ',',
        decimalScale: 2,
        fixedDecimalScale: true,
      },
    },

    Fieldset: {
      defaultProps: {
        classNames: {
          root: css.fieldset,
          legend: css.fieldsetLegend,
        },
      },
    },

    FileInput: {
      defaultProps: {
        component: 'button',
        color: 'primary',
      },
    },

    Modal: {
      defaultProps: {
        ...themeCfg?.commonProps,
      },
    },

    // ScrollArea: {
    //     defaultProps: {
    //         classNames: {
    //             root: css.scrollArea,
    //             scrollbar: css.scrollAreaScrollbar
    //         }
    //     }
    // }
  },
})
